export default __webpack_public_path__ + "media/images/cta_blocks/pick_your_theme-24e528eb9963bb7c03b0e707669c2f9b.jpg";